import React from 'react'
import { Form, FormControlProps, Row, Col } from 'react-bootstrap'

interface FormNumberProps extends Omit<FormControlProps, 'onChange'> {
	name: string
	label?: string
	required?: boolean
	feedback?: string
	min?: number
	max?: number
	onChange?: (value: number) => void
	labelCol?: number
	labelJustify?: 'start' | 'end' | 'center' | 'between' | 'around'
}

const FormNumber = (props: FormNumberProps) => {
	const { labelCol, labelJustify, ...htmlProps } = props

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let numValue = Number(e.target.value)
		if (props.min !== undefined) {
			numValue = Math.max(numValue, props.min)
		}
		if (props.max !== undefined) {
			numValue = Math.min(numValue, props.max)
		}
		if (props.onChange) {
			props.onChange(numValue)
		}
	}

	const control = (
		<>
			{props.readOnly ? (
				<Row className={'form-control-plaintext'}>
					<Col>{props.value}</Col>
				</Row>
			) : (
				<Form.Control type="number" {...htmlProps} onChange={handleChange} />
			)}
			{props.feedback ? <Form.Control.Feedback type="invalid">{props.feedback}</Form.Control.Feedback> : null}{' '}
		</>
	)

	return (
		<Form.Group controlId={props.name} as={labelCol ? Row : undefined}>
			{props.label ? (
				<Form.Label
					column={labelCol ? true : undefined}
					sm={labelCol || undefined}
					className={labelJustify ? `d-flex justify-content-${labelJustify}` : undefined}
				>
					{`${props.label}${props.required ? ' *' : ''}`}
				</Form.Label>
			) : null}

			{labelCol ? <Col sm={12 - labelCol}>{control}</Col> : control}
		</Form.Group>
	)
}

export { FormNumber }
